(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rivo-dual-filters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-rdf-root]').forEach((root) => {
      if (root.dataset.rdfReady === 'true') return;
      root.dataset.rdfReady = 'true';
      const options = [...root.querySelectorAll('[data-rdf-option]')];
      const variant = root.querySelector('[data-rdf-variant]');
      const price = root.querySelector('[data-rdf-price]');
      const unit = root.querySelector('[data-rdf-unit]');
      const visual = root.querySelector('[data-pack-visual]');
      const form = root.querySelector('.rdf-form');
      const mainButton = root.querySelector('[data-rdf-main-button]');
      const sticky = root.querySelector('[data-rdf-sticky]');
      const stickyPack = root.querySelector('[data-rdf-sticky-pack]');
      const stickyPrice = root.querySelector('[data-rdf-sticky-price]');
      const stickyAdd = root.querySelector('[data-rdf-sticky-add]');

      const selectOption = (option) => {
        options.forEach((item) => item.classList.toggle('is-active', item === option));
        const input = option.querySelector('input');
        if (input) input.checked = true;
        if (variant) variant.value = option.dataset.variant;
        if (price) price.textContent = option.dataset.price;
        if (unit) unit.textContent = `${option.dataset.unit} למסנן`;
        if (visual) visual.dataset.packVisual = option.dataset.count;
        if (stickyPack) stickyPack.textContent = option.querySelector('.rdf-option-title')?.textContent || '';
        if (stickyPrice) stickyPrice.textContent = option.dataset.price;
      };

      options.forEach((option) => {
        option.addEventListener('click', () => selectOption(option));
        option.querySelector('input')?.addEventListener('change', () => selectOption(option));
      });

      stickyAdd?.addEventListener('click', () => form?.requestSubmit());

      if (mainButton && sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }, { threshold: 0 });
        observer.observe(mainButton);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
